import React from "react";
import { Settings } from "@mui/icons-material";
import { Container } from "@mui/material";
import { Helmet } from "~/components/Helmet";
import * as Layout from "~/layout";
import {
  LayoutStateProvider,
  ScrollableContainer,
  SidebarSwitch,
  SidebarTrigger,
} from "~/layout";
import { SettingsSidebar } from "~/settings";
import { DsmNavigation } from "../../../DsmNavigation";
import { DataStoreDetails } from "./DataStoreDetails";

export function DataStoreDetailsPage() {
  return (
    <>
      <Helmet>
        <title>DataStore Details</title>
      </Helmet>
      <LayoutStateProvider>
        <Layout.Root>
          <Layout.Navigation>
            <DsmNavigation />
          </Layout.Navigation>
          <Layout.Header
            title="DataStore Details"
            actions={
              <SidebarTrigger
                sidebarId="settings"
                title="Settings"
                icon={<Settings />}
              />
            }
          />
          <Layout.Main>
            <ScrollableContainer>
              <Container fixed>
                <DataStoreDetails />
              </Container>
            </ScrollableContainer>
          </Layout.Main>
          <Layout.Sidebar>
            <SidebarSwitch
              options={[
                {
                  sidebarId: "settings",
                  element: <SettingsSidebar />,
                },
              ]}
            />
          </Layout.Sidebar>
        </Layout.Root>
      </LayoutStateProvider>
    </>
  );
}
